// import * as Sentry from '@sentry/react';
import debugFactory from 'debug';

import { sessionIncludesChoice } from '../category/check-category-lost';
import { useGlobalState } from '../global-state';

const debug = debugFactory('ingrid:user_choice');

/**
 * Notify to sentry about a situation where a user_choice or preselected_choice
 * is not present in the list of options, probably due to missing category.
 */
export function useInvalidChoiceDetection() {
  const globalState = useGlobalState();

  for (const session of globalState.sessions) {
    const backendChoice = session.user_choice ?? session.preselected_choice;
    if (!sessionIncludesChoice(session, backendChoice)) {
      const warning = `The choice "${JSON.stringify(backendChoice)}" is invalid`;
      debug(warning);
      /*
       * Update: there is too much sentry noise because of this, I think we
       * need a better way.
       */
      // Sentry.captureMessage(warning);
    }
  }
}
